module.exports = __webpack_public_path__ + "static/media/s_35.29771724.mp3";